"use client";

import { createIcon } from "@chakra-ui/react";

const ChevronDownSvgIcon = createIcon({
  displayName: "ChevronDownSvgIcon",
  viewBox: "0 0 20 20",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M4.99967 5.83203L9.99967 10.832L14.9997 5.83203L16.6663 7.4987L9.99967 14.1654L3.33301 7.4987L4.99967 5.83203Z" fill="currentColor" strokeWidth="current" />
  ),
});

export default ChevronDownSvgIcon;
